module.exports = __webpack_public_path__ + "img/Fluid_fr.4b813a23.jpg";